function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { isFunction } from '../utils';
export default {
  methods: {
    getNeedIndentSpaced: function getNeedIndentSpaced(records) {
      var childColName = this.childColName;
      return records.some(function (v) {
        return !!(v[childColName] && v[childColName].length);
      });
    },
    handleExpandRow: function handleExpandRow(renderFn, rowkey, record, indent, rowProps, ancestorKeys) {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          expandIconAsCell = this.expandIconAsCell,
          cols = this.cols,
          fixed = this.fixed,
          expandedRowClassName = this.expandedRowClassName,
          expandRowRefName = this.expandRowRefName;
      var idx = rowProps.idx;
      var parentKey = ancestorKeys[ancestorKeys.length - 1];
      var key = "".concat(parentKey, "-").concat(rowkey);
      var className = isFunction(expandedRowClassName) ? expandedRowClassName(record, idx, indent - 1) : '';
      var columns = [{
        cellRender: function cellRender() {
          return {
            colspan: cols.length,
            content: fixed !== 'right' ? renderFn(idx) : ''
          };
        }
      }];

      if (expandIconAsCell && fixed !== 'right') {
        columns.unshift({
          cellRender: function cellRender() {
            return '';
          }
        });
      }

      return h("table-row", {
        "attrs": {
          "rowPrefixCls": "".concat(prefixCls, "-expanded-row"),
          "cols": columns,
          "rowIdx": idx,
          "fixed": fixed,
          "uid": key,
          "ancestorKeys": ancestorKeys,
          "indent": indent,
          "expand-row": true
        },
        "ref": expandRowRefName,
        "refInFor": true,
        "key": key,
        "class": className
      });
    },
    renderExpandRow: function renderExpandRow(record, indent, rowProps, ancestorKeys) {
      var expandedRowRender = this.expandedRowRender,
          handleExpandRow = this.handleExpandRow;
      return handleExpandRow(function (rowIdx) {
        return isFunction(expandedRowRender) ? expandedRowRender(record, rowIdx, indent) : '';
      }, 'expand-row', record, indent, rowProps, ancestorKeys);
    },
    renderExpandSlotRow: function renderExpandSlotRow(record, indent, rowProps, ancestorKeys) {
      var rootScopedSlots = this.rootScopedSlots,
          handleExpandRow = this.handleExpandRow;
      var expandSlotRenderFn = rootScopedSlots.expand;
      return handleExpandRow(function (rowIdx) {
        return isFunction(expandSlotRenderFn) ? expandSlotRenderFn({
          record: record,
          rowIdx: rowIdx,
          indent: indent
        }) : '';
      }, 'expand-slot-row', record, indent, rowProps, ancestorKeys);
    },
    renderExpandRows: function renderExpandRows(record, indent, rowProps, ancestorKeys) {
      var rootScopedSlots = this.rootScopedSlots,
          childColName = this.childColName,
          renderRows = this.renderRows,
          expandedRowRender = this.expandedRowRender,
          renderExpandRow = this.renderExpandRow;
      var childrens = record[childColName];
      var rows = [];

      if (expandedRowRender) {
        rows.push(renderExpandRow(record, indent + 1, rowProps, ancestorKeys));
      }

      if (rootScopedSlots.expand) {
        rows.push(this.renderExpandSlotRow(record, indent + 1, rowProps, ancestorKeys));
      }

      if (childrens && childrens.length) {
        rows.push.apply(rows, _toConsumableArray(renderRows(childrens, indent + 1, rowProps, true, ancestorKeys)));
      }

      return rows;
    },
    renderHeaderExpandIconCell: function renderHeaderExpandIconCell(rowspan) {
      var prefixCls = this.prefixCls;
      var cell = {
        key: "".concat(prefixCls, "-expand-icon-cell"),
        className: "".concat(prefixCls, "-expand-icon-th"),
        title: '',
        rowspan: rowspan
      };
      cell.column = cell;
      return cell;
    }
  }
};